import React, { useEffect, useState, useContext, useLayoutEffect, useMemo } from "react";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";
import Pagination from '../../CommonUI/Pagination/Pagination';
import "./MFPeerComparison.css";
import { Vortex } from 'react-loader-spinner'

function MFPeerComparison(props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { MFcode } = useParams();
    const [loadingshow, setloadingshow] = useState(false);
    // console.log(MFCode, "MFCode")
    const [data, setData] = useState([]);
    let getMFCode = props.MFcode;
    let getcompname, getData;

    const { BaseURL } = useContext(URLstateContext);
    const [currentPage, setCurrentPage] = useState(1);
    let PageSize = 5;
    useEffect(() => {
        setloadingshow(true);
        if (getMFCode != '') {
            const getUrl = BaseURL + "PeerComparisonMF";
            // console.log(cocode)
            fetch(`${getUrl}/${getMFCode}`)
                // console.log(MFCode,"COCODE")
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                })
                .catch((error) => {
                    // console.log("not found the api 1233333");
                });
        }
    }, [getMFCode]);


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    const routeChange = (paramcode, paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }
    return (
        <>
            <section className="peer-sc">
                <div className='container table-boxpeerMutual'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className="mainHeadingGroup">Peer Comparison</h3>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-bordered table-hover">

                                    <thead className='heading'>
                                        <tr>
                                            <th scope="col">Fund Name</th>
                                            <th scope="col">1Y</th>
                                            <th scope="col">3Y</th>
                                            <th scope="col">5Y</th>
                                            <th scope="col">Fund Size(cr.)</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ YEAR1, YEAR3, YEAR5, Corpus, GRPNAME, mf_schcode }) => (
                                                <tr className="SameCompPeer ">
                                                    {/* <td><a href="" onClick={routeChange}  data-id={mf_schcode}>{GRPNAME}</a> </td> */}
                                                     <td>
                                                    {/*<h6 className="forhover" onClick={() => routeChange(mf_schcode, GRPNAME)}> */}
                                                        {GRPNAME} </td>
                                                    <td> {(YEAR1 != null) ? YEAR1.toFixed(2) : YEAR1 = 0}</td>
                                                    <td> {(YEAR3 != null) ? YEAR3.toFixed(2) : YEAR3 = 0}</td>
                                                    <td> {(YEAR5 != null) ? YEAR5.toFixed(2) : YEAR5 = 0}</td>
                                                    <td> {(Corpus != null) ? Corpus.toFixed(2) : Corpus = 0}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default MFPeerComparison;
